import type { Chart } from "../Chart";
import { Theme, Fonts } from "../theme";
import { computeTimeTicks } from "./ticks";

export function drawTimeAxis(ctx: CanvasRenderingContext2D, chart: Chart) {
  const vp = chart.viewport;
  const y0 = chart.fullPlotHeight;
  const h = chart.timeAxisHeight;
  const w = vp.plot.width;

  ctx.save();
  ctx.fillStyle = Theme.axisBg;
  ctx.fillRect(0, y0, chart.cssWidth, h);
  ctx.strokeStyle = Theme.axisBorder;
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(0, y0 + 0.5);
  ctx.lineTo(chart.cssWidth, y0 + 0.5);
  ctx.stroke();

  ctx.font = Fonts.axis;
  ctx.textBaseline = "middle";
  ctx.textAlign = "center";
  const labelY = y0 + h / 2;
  for (const t of computeTimeTicks(chart)) {
    if (t.x < 0 || t.x > w) continue;
    ctx.strokeStyle = Theme.axisBorder;
    ctx.beginPath();
    ctx.moveTo(Math.round(t.x) + 0.5, y0);
    ctx.lineTo(Math.round(t.x) + 0.5, y0 + 4);
    ctx.stroke();
    ctx.fillStyle = t.major ? Theme.text : Theme.textDim;
    ctx.fillText(t.label, t.x, labelY);
  }
  ctx.restore();
}
